import SeoHead from "@/Component/Seo/SeoHead";
import DownloadApp from "@/Component/Module/DownloadApp";
import { fetchPageSeo } from "@/utils/pageSeo";

export default function DownloadAppPage({ seo, seoCountry }) {
  return (
    <>
      <SeoHead
        seo={seo}
        country={seoCountry}
        fallbackTitle="Download App | Next Holidays"
      />
      <DownloadApp />
    </>
  );
}

export async function getServerSideProps(context) {
  const seoResult = await fetchPageSeo(context, {
    path: "/download-app",
  });

  if (seoResult.redirect) return seoResult;

  return {
    props: {
      seo: seoResult.seo,
      seoCountry: seoResult.seoCountry,
    },
  };
}
